
import {Component, Ref, Vue, Watch} from "vue-property-decorator";
import {ElForm} from "element-ui/types/form";
import api from "@/api";
import {
  ChangePartialAreaToNewBigAreaInput,
  ChangeStoreToNewPartialAreaInput,
  CreateOrEditDepartmentDto,
  OrganizationUnitLevel
} from "@/api/appService";
import {SelectListItem} from "@/core/common-type-definitions";

@Component({name:'ChangeStoreToNewPartialArea'})
export default class ChangeStoreToNewPartialArea extends Vue {
  @Ref() readonly dataForm!: ElForm;

  partialAreaId:number = 0;

  bigAreaList:SelectListItem<string>[] = []

  submitting = false;

  formData:ChangePartialAreaToNewBigAreaInput = {
    partialAreaId:0,
    newBigAreaId:undefined
  }

  created(){
    this.fetchOrganizationUnits();
  }

  @Watch('partialAreaId')
  onPartialAreaIdChange(){
    console.log('onPartialAreaIdChange:',this.partialAreaId);
    this.formData.partialAreaId = this.partialAreaId;
  }

  fetchOrganizationUnits(){
    api.organizationUnit.getOrganizationUnitsOfDescendantBySession().then(res=>{
      this.bigAreaList = res.filter(s=>s.level === OrganizationUnitLevel.大区)
        .map(org=>{
          return {value:org.id!.toString(),label:org.displayName} as SelectListItem<string>
        });
    });
  }



  defaultData: ChangePartialAreaToNewBigAreaInput = {
    partialAreaId: 0,
    newBigAreaId: undefined
  };

  show = false;
  form: ChangePartialAreaToNewBigAreaInput = { ...this.defaultData };

  async save() {
    if(!this.formData.newBigAreaId){
      this.$message.error('请选择大区');
      return ;
    }
    this.submitting = true;
    api.organizationUnit.changePartialAreaToNewArea({body:this.formData}).then(res=>{
      this.$message.success('变更成功');
      this.show = false;
      this.$emit('change-completed');
      this.submitting = false;
    }).catch(()=>{
      this.submitting = false;
    })
  }

  cancel() {
    this.show = false;
  }
}
